import React from "react";
import { Container } from "react-bootstrap";
import { Megaphone } from "lucide-react";
import PropTypes from "prop-types";
import { Input } from "antd";
import { UserOutlined } from "@ant-design/icons";

export default function Header({
  announcement,
  contentLoading,
  username,
  setUsername,
  password,
  setPassword,
  onSubmit,
  loading,
}) {
  return (
    <div style={{ backgroundColor: "#fcfaf7" }}>
      <Container
        // fluid
        className="d-flex align-items-center justify-content-between py-2 px-0 flex-wrap gap-2 mb-3"
      >
        {/* LEFT GROUP: logo + announcement */}
        <div className="d-flex align-items-center ">
          <img
            src="assets/img/logo.png"
            alt="IbizAccounts"
            style={{ width: "150px" }}
            className="mx-1"
          />

          {typeof announcement?.text === "string" &&
            announcement.text.trim() !== "" && (
              <div className="d-flex align-items-center gap-2 announcement-pill d-none d-lg-block">
                <Megaphone size={15} className="text-success flex-shrink-0" />

                {contentLoading ? (
                  <div
                    className="skeleton"
                    style={{ height: 14, width: 160 }}
                  />
                ) : (
                  <span
                    className="text-dark fw-semibold"
                    style={{ fontSize: 15.5 }}
                  >
                    {announcement.text}
                  </span>
                )}
              </div>
            )}
        </div>

        <div className="d-flex align-items-center gap-2">
          <form
            className="d-flex align-items-center gap-2 signin-inline-form"
            onSubmit={onSubmit}
          >
            <Input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              suffix={<UserOutlined />}
            />

            <Input.Password
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="submit"
              className="btn  btn-sm btn-primary "
              disabled={loading}
              aria-label="Sign in"
            >
              <i className="fa-solid fa-arrow-right fa-lg"></i>
            </button>
          </form>

          {/* <img
            src="assets/img/logo.png"
            alt="IbizAccounts"
            style={{ width: "150px" }}
            className="mx-1"
          /> */}
        </div>
      </Container>

      {typeof announcement?.text === "string" &&
        announcement.text.trim() !== "" && (
          <div className="d-flex align-items-center gap-2 announcement-pill d-block d-lg-none">
            <Megaphone size={15} className="text-success flex-shrink-0" />

            {contentLoading ? (
              <div className="skeleton" style={{ height: 14, width: 160 }} />
            ) : (
              <span
                className="text-dark fw-semibold"
                style={{ fontSize: 15.5 }}
              >
                {announcement.text}
              </span>
            )}
          </div>
        )}
    </div>
  );
}

Header.propTypes = {
  announcement: PropTypes.shape({
    text: PropTypes.string,
  }),
  contentLoading: PropTypes.bool,
  username: PropTypes.string,
  setUsername: PropTypes.func,
  password: PropTypes.string,
  setPassword: PropTypes.func,
  isPasswordVisible: PropTypes.bool,
  togglePasswordVisibility: PropTypes.func,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
};
